<template>
<div class="site-navbar row  el-container">
  <div class="col s12 yo-align-center">
    <el-menu default-active="1"  mode="horizontal" :router="true" @select="handleSelect">
      <el-menu-item index="/" class="">HOME</el-menu-item>

      <el-submenu index="a" class="">
          <template slot="title">INVITATION</template>
          <el-menu-item index="/loadpage/invitation/president-invitation" class="font-color-e">President’s Invitation</el-menu-item>
          <el-menu-item index="/loadpage/invitation/society-invitation" class="font-color-e">Society Invitation</el-menu-item>
      </el-submenu>

      <li class="el-menu-item"><a href="https://hotel.kenes.com/en/congress/EUROMED19"  target="_blank">HOTELS</a></li>

      <!--
          <el-menu-item index="/loadpage/comitati/comitati" class="">LOGO</el-menu-item>
      -->
      <el-submenu index="b" class="">
          <template slot="title">PROGRAMME</template>
          <!-- <li class="el-menu-item"><a :href="'/2019/documenti/WeekAgenda.pdf?random='+$teras.random()"  target="_blank">Week Agenda</a></li> -->
          <el-menu-item index="/loadpage/programme/week-agenda" class="font-color-e">Week Agenda</el-menu-item> 
          <!-- <li class="el-menu-item"><a href="http://bvent.biomedia.net/s/2132" target="_blank">Scientific Programme</a> </li> -->
          <el-menu-item index="/loadpage/programme/scientific-programme" class="font-color-e">Scientific Programme</el-menu-item>
          
          <!-- <li class="el-menu-item"><a :href="'/2019/documenti/EducationalWorkshops.pdf?random='+$teras.random()"  target="_blank">Educational Workshops</a></li> -->
          <el-menu-item index="/educational-workshops" class="font-color-e">Educational Workshops</el-menu-item>
          <el-menu-item index="/loadpage/programme/satellite-meetings" class="font-color-e">Satellite Meetings</el-menu-item>
      </el-submenu>

      <el-menu-item index="/loadpage/abstracts/abstracts" class="">ABSTRACTS</el-menu-item>

      <el-submenu index="c" class="">
          <template slot="title">REGISTRATIONS</template>
          <el-menu-item index="/loadpage/registrations/registrations" class="font-color-e">Registration</el-menu-item>
          <el-menu-item index="/loadpage/registrations/bursary" class="font-color-e">EFLM Bursary Programme</el-menu-item>
          <el-menu-item index="/loadpage/registrations/scholarship" class="font-color-e">IFCC Travel Scholarships</el-menu-item>
          <el-menu-item index="/loadpage/registrations/awards" class="font-color-e">Awards</el-menu-item>
      </el-submenu>

      <!-- <el-menu-item index="/loadpage/sponsor/sponsor" class="">SPONSOR</el-menu-item>-->

      <el-submenu index="sponsor" class="">
          <template slot="title">SPONSOR</template>
          <el-menu-item index="/loadpage/sponsor/sponsor" class="">Sponsor</el-menu-item>
          <el-menu-item index="/loadpage/sponsor/mediapartner" class="">Media Partners</el-menu-item>
      </el-submenu>

      <el-submenu index="d" class="">
          <template slot="title">INFO</template>
          <el-menu-item index="/loadpage/info/organising-secretariat" class="font-color-e">Organising Secretariat</el-menu-item>
          <el-menu-item index="/loadpage/info/congress-venue" class="font-color-e">Congress Venue</el-menu-item>
          <el-menu-item index="/loadpage/info/general-information" class="font-color-e">General Information</el-menu-item>
          <el-menu-item index="/loadpage/committees/committees" class="font-color-e">Committees</el-menu-item>
          <el-menu-item index="/loadpage/info/newsletters" class="font-color-e">Newsletters</el-menu-item>
          <!-- <el-menu-item index="/loadpage/info/logo" class="font-color-e">Logo</el-menu-item> -->
      </el-submenu>
    </el-menu> 



  </div>
</div>
</template>

<script>
export default {
  name: 'site-navbar',
  created () {
    console.log("Created Site-logged.vue")
    console.log(this.$axios.mysql)
    this.$axios.sessionGet('session_id').then((data) => {
      console.log("))))))))))))))))))))))))))))))))")
      console.log(data.key)
    })
  },
  methods: {
    handleSelect(key, keyPath) {
      /*
        if(keyPath=='/sezione/2/'){
            
        }
        else if(keyPath=='/page/f/4'){
           
        }
        else {
            
        }
        */
        console.log(key)
        console.log(keyPath)
        

    }
  }
}
</script>

<style>

/* SITE-NAVBAR */
.site-navbar{
  background: #283480;
}.site-navbar ul.el-menu{
  background: transparent !important;
  margin:0 auto !important;
}.site-navbar li, .site-navbar .el-submenu .el-submenu__title, .site-navbar .el-submenu.is-active .el-submenu__title, .site-navbar .el-submenu .el-submenu__icon-arrow{
  color:#ffffff !important;
  font-size:1.3rem;
  letter-spacing: -.6px;
  padding:0;
  text-align:center;
  line-height:42px  !important;
  height:42px  !important;
  border:none !important;
}.site-navbar .el-menu > .el-menu-item, .site-navbar .el-menu > .el-submenu{
  width: 12.5% !important;
  color:#ffffff !important;
  font-size:1.3rem;
  line-height:42px  !important;
  height:42px  !important;
  border:none !important;
}li.el-menu-item:last-child{
  margin:0;    
}.site-navbar .el-menu-item:hover,.site-navbar .el-menu-item:focus, .site-navbar .el-submenu:hover , .site-navbar .el-submenu:hover .el-submenu__title:hover{
  color:#ffffff !important;
  background-color: #F6A015 !important;
}.site-navbar .el-submenu > .el-menu{
  width:100px !important;
}.site-navbar .el-submenu > .el-menu .el-menu-item{
  color:#ffffff;
  background-color: #F6A015 !important;
  padding:0 10px;
  text-align:left;
  width: 100px !important;
  overflow:hidden;
  margin:0;
}.el-menu-item a{
  display:block;
  
}.el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title{
  color:#ffffff !important;
  background-color: #F6A015  !important;
  border-bottom:none !important;
  border:none !important;
}.el-menu--horizontal .el-menu {
  background-color: #F6A015  !important;
  color:#ffffff !important;
  margin-top:0;
}.el-menu--popup{
  border-radius: 0 !important;
  box-shadow:0em !important;
}
</style>
